import { z } from 'zod'
import { SessionUserSchema } from '@shared/lib/auth/session-types'

const StaffSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  name: z.string().optional(),
  isSuper: z.boolean().default(false),
  permissions: z.array(z.string()).default([]),
})

export const AuthResponseSchema = z.preprocess(
  (value) => {
    if (value && typeof value === 'object' && 'staff' in value) {
      const raw = value as { token?: unknown; staff?: unknown }
      const staff = StaffSchema.parse(raw.staff)
      return {
        token: raw.token,
        user: {
          id: staff.id,
          email: staff.email,
          name: staff.name,
          isSuper: staff.isSuper,
          permissions: staff.permissions,
        },
      }
    }
    return value
  },
  z.object({
    token: z.string().min(1),
    user: SessionUserSchema,
  }),
)

export type AuthResponse = z.infer<typeof AuthResponseSchema>

export const StaffMeResponseSchema = z.preprocess((value) => {
  if (value && typeof value === 'object' && 'staff' in value) {
    const raw = value as { staff?: unknown }
    const staff = StaffSchema.parse(raw.staff)
    return {
      id: staff.id,
      email: staff.email,
      name: staff.name,
      isSuper: staff.isSuper,
      permissions: staff.permissions,
    }
  }
  return value
}, SessionUserSchema)

export const LoginInputSchema = z.object({
  email: z.string().email('Informe um e-mail válido.'),
  password: z.string().min(1, 'Informe sua senha.'),
  recaptchaToken: z.string().optional(),
})

export type LoginInput = z.infer<typeof LoginInputSchema>
